import AnswerStatusChip from "@memorang/ui/src/components/AnswerStatusChip";
import Box from "@memorang/ui/src/components/Box";
import TooltipWrapper from "@memorang/ui/src/components/TooltipWrapper";

type AnswerStatusRowProps = {
	numCorrect: number;
	numIncorrect: number;
	numSkipped: number;
	tagLabel?: string;
	isOverall?: boolean;
};

const AnswerStatusRow = ({
	numCorrect,
	numIncorrect,
	numSkipped,
	tagLabel,
	isOverall = false,
}: AnswerStatusRowProps) => {
	const topicText = isOverall
		? "all topics"
		: `the ${tagLabel || "this topic"} topic`;

	const correctTooltip = `In ${topicText}, you answered ${numCorrect} correctly, ${numIncorrect} incorrectly, and skipped ${numSkipped}. Skipped items are scored as incorrect.`;
	const incorrectTooltip = `In ${topicText}, you answered ${numIncorrect} incorrectly, ${numCorrect} correctly, and skipped ${numSkipped}. Skipped items are scored as incorrect.`;
	const skippedTooltip = `In ${topicText}, you skipped ${numSkipped}, answered ${numCorrect} correctly, and ${numIncorrect} incorrectly. Skipped items are scored as incorrect.`;
	return (
		<Box flexDirection="row" alignItems="center" gap={8}>
			<TooltipWrapper title={correctTooltip}>
				<AnswerStatusChip status={"correct"} label={`${numCorrect}`} />
			</TooltipWrapper>
			<TooltipWrapper title={incorrectTooltip}>
				<AnswerStatusChip status={"incorrect"} label={`${numIncorrect}`} />
			</TooltipWrapper>
			<TooltipWrapper title={skippedTooltip}>
				<AnswerStatusChip status={"skipped"} label={`${numSkipped}`} />
			</TooltipWrapper>
		</Box>
	);
};

export default AnswerStatusRow;
